import { FC, PropsWithChildren } from 'react'
// import { useResolutionLimit } from '../../hooks/useResolutionLimit'
// import { UnderLimit } from './UnderLimit'

/**
 * ResolutionLimit component - DISABLED for responsive design
 *
 * This component previously blocked access on screens < 1152px
 * Now disabled to allow responsive design to work on all devices
 *
 * The app now supports:
 * - Mobile: 320px - 767px
 * - Tablet: 768px - 1023px
 * - Desktop: 1024px+
 */
export const ResolutionLimit: FC<PropsWithChildren> = ({ children }) => {
  // Disabled resolution limit check for responsive design
  // const { isUnderLimit } = useResolutionLimit()
  // return <>{isUnderLimit ? <UnderLimit /> : <>{children}</>}</>

  // Always render children to support all screen sizes
  return <>{children}</>
}
